import { ScheduleTypeFragment } from 'pages/vacancy/api/fragments/generated/ScheduleType.fragment';

export const getScheduleTypeName = (schedules: ScheduleTypeFragment[], id?: string | null) => {
  const res = schedules.find(el => el.id === id);
  if (!res) return '';
  return res.name;
};
